import { Markdown } from '@/components/Markdown';
import Translator, { useTranslation } from '@/components/i18n/Translator';

export default function WaterMark() {
  const { t } = useTranslation();

  return (
    <div
      className="watermark"
      style={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none'
      }}
    >
      <div className="text-xs text-muted-foreground">
        <div className="text-center"><Translator path="chat.watermark" /></div>
        <div className="text-center">
        <span>[测试版] © 2026 指边科技版权所有 | <a href="/about/" className="underline hover:no-underline">关于我们</a> | </span>
        <span>
          <a href="https://beian.miit.gov.cn/" target="_blank" className="z2 ml-1">京ICP备2024082242号-4</a> | 
          <img style={{width: '16px'}} className="inline-block mx-1" src="https://beian.mps.gov.cn//web/assets/logo01.6189a29f.png" data-v-2996d565="" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045359" rel="noreferrer" target="_blank" className="z2">京公网安备11010802045359号</a>
        </span>
        </div>
      </div>
    </div>
  );
}
